import { Component } from 'react';
import SurveyQuizBarLayout from './SurveyQuizBarLayout';

class SurveyQuizBar extends Component {
  constructor(props) {
    super(props)
  }

  isCheckededQuestion = (current, question) => {
    if (question <= current){
      return true
    }
    return false
  }

  isCurrentQuestion = (current, question) => {
    if (question == current){
      return true
    }
    return false
  }

  render() {
    return(
      <SurveyQuizBarLayout
        {...this.props}
        isCheckededQuestion={this.isCheckededQuestion}
        isCurrentQuestion={this.isCurrentQuestion}
        currentQuestionI={0}
      />
    )
  }
}

export default SurveyQuizBar;
